export default __webpack_public_path__ + "assets/43ec15ea029693e96fde94c855e7ee3f.jpg";